import axios from "../axios-private";

export function createDocumentation(request) {
    return axios.post("/documentation", request);
}

export function editDocumentation(id, request) {
    return axios.put(`/documentation/${id}`, request);
}

export function deleteDocumentation(id) {
    return axios.delete(`/documentation/${id}`);
}

export function getDocumentation() {
    return axios.get(`/documentation/public`);
}
